export default "__VITE_ASSET__Bcdt40Q$__"